import React, { useState } from 'react';

import { withToolbarContext } from './../../../../ricos-context';
import { getIsModalOpen, useModalState } from './../../../../ricos-modals/modal-service-provider';
import { Node_Type } from './../../../../ricos-schema/legacy/wix/rich_content/v1';
import { headingsMap, translateHeading } from './../../../../toolbars-modals';

import { DropdownArrowIcon } from '../../../icons';
import { ToolbarButton } from '../ToolbarButton';

const HeadingButton = ({ toolbarItem, context, dataHook }: $TSFixMe) => {
  const { isMobile, t } = context || {};
  const isModalOpen = useModalState(getIsModalOpen(`${Node_Type.HEADING}.modal`));
  const [referenceElement, setReferenceElement] = useState<HTMLButtonElement | null>(null);

  const selectedHeading = toolbarItem.attributes.selectedHeading;
  const Label = translateHeading(
    headingsMap[selectedHeading as $TSFixMeKey<typeof headingsMap>],
    t
  );

  const tooltip = t(toolbarItem.presentation?.tooltip);
  return (
    <ToolbarButton
      ref={setReferenceElement}
      disabled={toolbarItem.attributes.disabled}
      isMobile={isMobile}
      active={isModalOpen}
      tooltip={tooltip}
      onClick={e => toolbarItem.commands?.click({ referenceElement, clickFromKeyboard: !e.detail })}
      icon={() => (
        <>
          {Label}
          <DropdownArrowIcon />
        </>
      )}
      dataHook={dataHook}
    />
  );
};

export default withToolbarContext(HeadingButton);
